import React, { Component, Fragment } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import {
  Grid,
  Checkbox,
  FormControlLabel,
  Menu,
  MenuItem,
} from "@mui/material";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Table from "../common/tableWithBackEndPagination";
import TextField from "../common/TextField";
import Button from "../common/Button";
import Loader from "../../Layout/Loader";
import CustomDatePicker from "../common/CustomDatePicker";
import { checkPrivileges } from "../../Helpers";

const styles = () => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
});

let source;

class VehicleExpiryList extends Component {
  constructor(props) {
    super(props);
    const initialTab = props.initialTab === "overdue" ? "overdue" : "due";
    this.state = {
      expiryTab: initialTab,
      dataReceived: false,
      list: null,
      noRecords: false,
      rowsPerPage: 10,
      pageSize: 10,
      page: 1,
      itemSearch: "",
      date: moment().endOf("day").toISOString(),
      compliance: true,
      insurance: true,
      licence: true,
      all: true,
      filterAnchorEl: null,
    };
  }

  componentDidMount() {
    this.fetchList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.initialTab !== this.props.initialTab) {
      const nextTab =
        this.props.initialTab === "overdue" ? "overdue" : "due";
      this.handleChangeTab(nextTab, { updateUrl: false });
    }
  }

  componentWillUnmount() {
    if (source) source.cancel();
  }

  getApiEndpoint = () => {
    const { expiryTab } = this.state;
    return expiryTab === "overdue"
      ? "vehicleexpiryoverdue"
      : "vehicleexpirydue";
  };

  fetchList = () => {
    const {
      page,
      pageSize,
      date,
      compliance,
      insurance,
      licence,
      all,
      itemSearch,
    } = this.state;

    const endpoint = this.getApiEndpoint();
    let api = `/api/vehicles/${endpoint}?date=${date}&compliance=${compliance}&insurance=${insurance}&licence=${licence}&page=${page}&limit=${pageSize}`;
    if (itemSearch) api += `&search=${encodeURIComponent(itemSearch)}`;

    this.setState({ dataReceived: false });

    source = axios.CancelToken.source();
    axios
      .get(api, { cancelToken: source.token })
      .then((res) => {
        const list = res?.data?.data;
        const rows = list?.data || [];
        this.setState({
          list,
          dataReceived: true,
          noRecords: rows.length === 0,
        });
      })
      .catch((e) => {
        if (!axios.isCancel(e)) {
          toast.error(this.props.translate("somethingWentWrong"));
          this.setState({ dataReceived: true, noRecords: true });
        }
      });
  };

  handleChangeTab = (tab, { updateUrl = true } = {}) => {
    if (tab === this.state.expiryTab) return;
    if (source) source.cancel();
    this.setState(
      { expiryTab: tab, page: 1, dataReceived: false, list: null },
      this.fetchList,
    );
    if (updateUrl && this.props.navigate) {
      const search = tab === "overdue" ? "?tab=overdue" : "";
      this.props.navigate(`/vehicle-expiry${search}`, { replace: true });
    }
  };

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  setPagination = () => {
    const { list, pageSize } = this.state;
    if (list && list.data && list.data.length) {
      const nData = { ...list };
      const lastPage = nData.total / pageSize;
      const IsFloate = this.checkFloteNumber(lastPage);
      delete nData.data;
      nData.pageSize = pageSize;
      nData.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
      return nData;
    }
    return {};
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ pageSize: rowsPerPage, page: 1 }, this.fetchList);
  };

  handleChangePage = (value) => {
    this.setState({ page: value }, this.fetchList);
  };

  SearchItem = (searchValue) => {
    if (source) source.cancel();
    this.setState({ page: 1, itemSearch: searchValue }, this.fetchList);
  };

  openFilterMenu = (e) => {
    this.setState({ filterAnchorEl: e.currentTarget });
  };

  closeFilterMenu = () => {
    this.setState({ filterAnchorEl: null });
  };

  toggleAllFilters = (checked) => {
    this.setState(
      {
        all: checked,
        compliance: checked,
        insurance: checked,
        licence: checked,
        page: 1,
      },
      this.fetchList,
    );
  };

  toggleSingleFilter = (field) => (e) => {
    const checked = e.target.checked;
    this.setState(
      (prev) => {
        const next = { ...prev, [field]: checked, page: 1 };
        const nextAll = !!(next.compliance && next.insurance && next.licence);
        next.all = nextAll;
        return next;
      },
      () => this.fetchList(),
    );
  };

  handleDateChange = (value) => {
    if (!value) return;
    const iso = moment(value)
      .endOf("day")
      .set({ millisecond: 999 })
      .toISOString();
    this.setState({ date: iso, page: 1 }, this.fetchList);
  };

  onEditVehicle = (item) => {
    if (!item || !this.props.navigate) return;
    this.props.navigate("/vehicle", {
      state: { editVehicle: item, returnTo: "/vehicle-expiry" },
    });
  };

  onContractNumberClick = (contractNumber) => {
    if (!contractNumber || !this.props.navigate) return;
    this.props.navigate(
      `/accounts?search=${encodeURIComponent(contractNumber)}`,
    );
  };

  render() {
    const {
      dataReceived,
      noRecords,
      compliance,
      insurance,
      licence,
      all,
      filterAnchorEl,
      expiryTab,
    } = this.state;
    const { themecolors, translate } = this.props;
    const themeColor = themecolors?.themeLightColor || "#1a3a6b";
    const filterMenuOpen = Boolean(filterAnchorEl);

    const tabButtonStyle = (tab) => ({
      width: "50%",
      borderTopRightRadius: "15px",
      borderTopLeftRadius: "15px",
      marginLeft: "5px",
      backgroundColor: expiryTab === tab ? themeColor : "#ffff",
      color: expiryTab === tab ? "#ffff" : themeColor,
    });

    return (
      <Fragment>
        <Grid container className="breadcrumb-row">
          <Grid item xs={12} sm={4} style={{ display: "flex" }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => this.handleChangeTab("due")}
              style={tabButtonStyle("due")}
            >
              {translate("fleetExpiryDue")}
            </Button>
            <Button
              variant="contained"
              onClick={() => this.handleChangeTab("overdue")}
              style={tabButtonStyle("overdue")}
            >
              {translate("fleetExpiryOverdue")}
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            sm={8}
            style={{
              justifyContent: "flex-end",
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 6,
            }}
          >
            <Button
              size="small"
              variant="outlined"
              onClick={this.openFilterMenu}
            >
              {translate("filter")}
            </Button>
            <Menu
              anchorEl={filterAnchorEl}
              open={filterMenuOpen}
              onClose={this.closeFilterMenu}
            >
              <MenuItem>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={all}
                      onChange={(e) => this.toggleAllFilters(e.target.checked)}
                      size="small"
                    />
                  }
                  label={translate("all")}
                />
              </MenuItem>
              <MenuItem>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={licence}
                      onChange={this.toggleSingleFilter("licence")}
                      size="small"
                    />
                  }
                  label={translate("licence")}
                />
              </MenuItem>
              <MenuItem>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={insurance}
                      onChange={this.toggleSingleFilter("insurance")}
                      size="small"
                    />
                  }
                  label={translate("insurance")}
                />
              </MenuItem>
              <MenuItem>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={compliance}
                      onChange={this.toggleSingleFilter("compliance")}
                      size="small"
                    />
                  }
                  label={translate("compliance")}
                />
              </MenuItem>
            </Menu>
            <div style={{ width: 190 }}>
              <CustomDatePicker
                fullWidth
                label={translate("date")}
                format="YYYY-MM-DD"
                views={["year", "month", "day"]}
                value={this.state.date}
                onChange={this.handleDateChange}
                disableTopMargin
              />
            </div>
            <div style={{ width: 220 }}>
              <TextField
                fullWidth
                label={translate("search")}
                onChange={(e) => this.SearchItem(e.target.value)}
              />
            </div>
          </Grid>
        </Grid>

        {dataReceived && !noRecords ? (
          <Table
            rows={this.state.list?.data || []}
            translate={translate}
            pagination={this.setPagination()}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleChangePage={this.handleChangePage}
            rowsPerPage={this.state.rowsPerPage}
            ServerSetting={this.props.ServerSetting}
            isEditable={checkPrivileges("vehicleUpdate")}
            isCursoPointer
            isVehicleTable
            onClick={this.onEditVehicle}
            onContractNumberClick={this.onContractNumberClick}
            hasAccessOfUpdate={checkPrivileges("vehicleUpdate")}
            themecolors={themecolors}
            rowDefinition={rowDefinition(translate)}
          />
        ) : !dataReceived ? (
          <div style={{ textAlign: "center" }}>
            <Loader defaultStyle />
          </div>
        ) : null}

        {noRecords && dataReceived && (
          <div style={{ textAlign: "center" }}>
            <h4>{translate("noRecordFound")}</h4>
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  themecolors: state.themecolors,
});

const enhance = compose(withStyles(styles), connect(mapStateToProps));
export default enhance(VehicleExpiryList);

const rowDefinition = (translate) => [
  { id: "label", label: translate("label") },
  { id: "category", label: translate("vehicleType") },
  {
    id: "vehicleLicensePlate",
    numeric: false,
    disablePadding: false,
    label: translate("vehicleLicensePlate"),
  },
  {
    id: "attributes.parentName",
    numeric: false,
    disablePadding: false,
    label: translate("account"),
  },
  {
    id: "attributes.contractNumber",
    numeric: false,
    disablePadding: false,
    label: translate("contractNumber"),
  },
  {
    id: "makeName",
    numeric: false,
    disablePadding: false,
    label: translate("make"),
  },
  {
    id: "purchaseDate",
    numeric: false,
    disablePadding: false,
    label: translate("purchaseDate"),
  },
  {
    id: "year",
    numeric: false,
    disablePadding: false,
    label: translate("year"),
  },
  {
    id: "vin",
    numeric: false,
    disablePadding: false,
    label: translate("vin"),
  },
  {
    id: "deliveryDate",
    numeric: false,
    disablePadding: false,
    label: translate("deliveryDate"),
  },
  {
    id: "attributes.depreciationCost",
    numeric: false,
    disablePadding: false,
    label: translate("depreciationCost"),
  },
  {
    id: "attributes.autoRegister",
    numeric: false,
    disablePadding: false,
    label: translate("creationMode"),
  },
  {
    id: "attributes.reason",
    numeric: false,
    disablePadding: false,
    label: translate("reason"),
  },
  {
    id: "created",
    numeric: false,
    disablePadding: false,
    label: translate("created"),
  },
];
